module.exports = __webpack_public_path__ + "static/media/inside-logo-white.e3f9d318.svg";